import { Link } from "@tanstack/react-router";
import { Briefcase } from "lucide-react";
import type * as React from "react";
import {
  EntityCardContent,
  EntityCardsGrid,
  entityCardClass,
} from "@/components/shared/entity-cards";
import { LifecycleBadge } from "@/components/shared/lifecycle-badge";
import type { Role } from "@/hooks/use-roles";
import { carryListSearch } from "@/lib/list-search";

interface RoleCardsProps {
  roles: Role[];
  loading?: boolean;
  empty: React.ReactNode;
}

export function RoleCards({ roles, loading, empty }: RoleCardsProps) {
  return (
    <EntityCardsGrid loading={loading} isEmpty={roles.length === 0} empty={empty}>
      {roles.map((role) => (
        <Link
          key={role.id}
          to="/dashboard/roles/$roleId"
          params={{ roleId: role.id }}
          search={carryListSearch()}
          aria-label={`Open ${role.name}`}
          className={entityCardClass(true)}
        >
          <EntityCardContent
            icon={Briefcase}
            title={role.name}
            subtitle={role.departmentName || "No department"}
            trailing={<LifecycleBadge status={role.status} />}
          />
        </Link>
      ))}
    </EntityCardsGrid>
  );
}
